if (!window.Eurus.loadedScript.has('cart-drawer-turkish-coffee.js')) {
  window.Eurus.loadedScript.add('cart-drawer-turkish-coffee.js');

  function registerCartDrawerTurkishCoffee() {
    Alpine.data('xCartDrawerTurkishCoffee', (variantId) => ({
      qty: 1,
      loading: false,
      error: '',
      imagePopupUrl: '',
      imageAlt: '',
      showImagePopup: false,
      popupStyle: '',
      _popupTimer: null,
      init() {
        const root = this.$el;
        if (!root) return;
        this.imagePopupUrl = root.dataset.tcPopupUrl || '';
        this.imageAlt = root.dataset.tcPopupAlt || '';
      },
      showImagePreview() {
        if (!this.imagePopupUrl) return;

        const isMobile = window.matchMedia('(max-width: 1023px)').matches;
        if (isMobile) {
          const card = this.$refs.tcCard;
          const rect = card ? card.getBoundingClientRect() : null;
          const top = rect ? Math.max(12, rect.top - 10) : window.innerHeight * 0.35;
          this.popupStyle = `left:50%;top:${top}px;`;
        } else {
          const btn = this.$refs.tcMedia;
          if (!btn) return;
          const rect = btn.getBoundingClientRect();
          this.popupStyle = `left:${rect.left + rect.width / 2}px;top:${Math.max(8, rect.top - 6)}px;`;
        }

        this.showImagePopup = true;

        if (this._popupTimer) clearTimeout(this._popupTimer);
        this._popupTimer = setTimeout(() => {
          this.showImagePopup = false;
        }, 2000);
      },
      minusQty() {
        if (this.qty > 1) this.qty -= 1;
      },
      plusQty() {
        if (this.qty < 99) this.qty += 1;
      },
      clampQty() {
        const n = parseInt(this.qty, 10);
        if (!Number.isFinite(n) || n < 1) this.qty = 1;
        else if (n > 99) this.qty = 99;
        else this.qty = n;
      },
      async addToCart() {
        if (this.loading) return;
        this.clampQty();
        this.loading = true;
        this.error = '';

        await Alpine.store('xCartHelper').waitForCartUpdate();
        window.updatingCart = true;

        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              items: [
                {
                  id: variantId,
                  quantity: this.qty,
                  properties: {
                    _workshop_addon: 'true',
                    _addon_title: 'Turkish Coffee',
                    _addon_source: 'cart_drawer',
                  },
                },
              ],
              sections: Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id),
              sections_url: window.location.pathname,
            }),
          });

          const data = await response.json();

          if (!response.ok || data.status === 422) {
            this.error = (data.description || data.message || 'Unable to add to cart.').slice(0, 200);
            return;
          }

          Alpine.store('xCartHelper').reRenderSections(data.sections);
          const bubble = document.querySelector('#cart-icon-bubble span');
          if (bubble) {
            Alpine.store('xCartHelper').currentItemCount = parseInt(bubble.innerHTML, 10);
          }
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          this.qty = 1;
        } catch (err) {
          this.error = 'Unable to add to cart.';
        } finally {
          this.loading = false;
          window.updatingCart = false;
        }
      },
    }));
  }

  if (window.Alpine) {
    registerCartDrawerTurkishCoffee();
  } else {
    document.addEventListener('alpine:init', registerCartDrawerTurkishCoffee);
  }
}
